import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { defineMessages, injectIntl, intlShape } from 'react-intl'
import ConvPy from '../green-flag/convpy.jsx'

import GreenFlag from '../green-flag/green-flag.jsx'
import StopAll from '../stop-all/stop-all.jsx'
import TurboMode from '../turbo-mode/turbo-mode.jsx'
import { BrowserView, MobileView } from 'react-device-detect'

import styles from './controls.css'
import CustomPopup from '../customPopup/customPopup.jsx'

const messages = defineMessages({
    goTitle: {
        id: 'gui.controls.go',
        defaultMessage: 'Go',
        description: 'Green flag button title',
    },
    stopTitle: {
        id: 'gui.controls.stop',
        defaultMessage: 'Stop',
        description: 'Stop button title',
    },
    ConvPyTitle: {
        id: 'gui.controls.ConvPy',
        defaultMessage: 'Convert to python',
        description: 'blocks to python',
    },
})

const Controls = function (props) {
    const {
        active,
        className,
        intl,
        onGreenFlagClick,
        onStopAllClick,
        onConvPyClick,
        turbo,
        handelConsoleClear,
        // Custom / Redux props used in JSX — destructured here so they are NOT
        // spread onto the native <div> (which would trigger React DOM warnings).
        currentMode,
        onUSBConnectClick, // eslint-disable-line no-unused-vars
        handelScriptChange,
        isShow,
        popupMessage,
        popupTitle,
        handelClosePopup,
        popupOnConfirm,
        popupConfirmLabel,
        portBusy,          // eslint-disable-line no-unused-vars
        setPortBusy,       // eslint-disable-line no-unused-vars
        resetPortBusy,     // eslint-disable-line no-unused-vars
        setCurrentMode,    // eslint-disable-line no-unused-vars
        showDeviceAlert,   // eslint-disable-line no-unused-vars
        worker,            // eslint-disable-line no-unused-vars
        codes,             // eslint-disable-line no-unused-vars
        dispatch,          // eslint-disable-line no-unused-vars
        // eslint-disable-next-line no-unused-vars
        vm,
        ...componentProps  // only valid HTML attributes remain
    } = props

    return (
        <div
            className={classNames(styles.controlsContainer, className)}
            {...componentProps}
        >
            {/*  show the popup message */}
            <CustomPopup
                isShow={isShow}
                handelClosePopup={handelClosePopup}
                popupMessage={popupMessage}
                popupTitle={popupTitle}
                onConfirm={popupOnConfirm}
                confirmLabel={popupConfirmLabel}
            />

            <GreenFlag
                active={active}
                title={intl.formatMessage(messages.goTitle)}
                onClick={onGreenFlagClick}
            />
            {/* language toggle moved to the right-side sidebar */}

            {/* {props.currentMode.isCodingMode && (
                <button onClick={handelConsoleClear}>clear</button>
            )} */}
            <BrowserView>
                {/* <ConvPy
                    active={active}
                    title={intl.formatMessage(messages.ConvPyTitle)}
                    onClick={onConvPyClick}
                ></ConvPy> */}
            </BrowserView>

            {turbo ? <TurboMode /> : null}
        </div>
    )
}

Controls.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    intl: intlShape.isRequired,
    onGreenFlagClick: PropTypes.func.isRequired,
    onStopAllClick: PropTypes.func,
    onConvPyClick: PropTypes.func.isRequired,
    turbo: PropTypes.bool,
    currentMode: PropTypes.object,
    handelConsoleClear: PropTypes.func,
    handelScriptChange: PropTypes.func,
    isShow: PropTypes.bool,
    handelClosePopup: PropTypes.func,
    popupMessage: PropTypes.string,
    popupTitle: PropTypes.string,
}

Controls.defaultProps = {
    active: false,
    turbo: false,
    currentMode: {},
    isShow: false,
    handelConsoleClear: () => {},
    handelScriptChange: () => {},
    handelClosePopup: () => {},
    popupMessage: '',
    popupTitle: '',
}

export default injectIntl(Controls)
